import { Form } from "antd";

import ExportButton from "./ExportButton";
import FilterSelect from "./FilterSelect";
import { useFilters } from "./hooks/useFilters";

const ExportLocation = () => {
  const [params, setFilters] = useFilters();
  return (
    <Form layout="vertical">
      <FilterSelect
        model="locations"
        onChange={(value) => setFilters("id", value)}
      />
      <FilterSelect
        model="organizations"
        onChange={(value) => setFilters("organization_id", value)}
      />
      <ExportButton model="locations" params={params} />
    </Form>
  );
};

export default ExportLocation;
